import { render, staticRenderFns } from "./work-classifications-view.vue?vue&type=template&id=1c3519fb&"
import script from "./work-classifications-view.vue?vue&type=script&lang=js&"
export * from "./work-classifications-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports